;(function () {
  angular
    .module('contrast.password')
    .directive('csPasswordMeter', csPasswordMeter)

  function csPasswordMeter(ProfileFactory, PasswordMeterService) {
    'ngInject'

    return {
      restrict: 'E',
      scope: {
        password: '@',
        valid: '=?'
      },
      templateUrl: 'views/common/password_meter.html',
      link: function (scope, element, attrs) {
        PasswordMeterService.initialize(scope)

        ProfileFactory.getAdditivePolicy().then(function (response) {
          PasswordMeterService.setRestrictions(response.data.policy, scope)
        })

        attrs.$observe('password', function (value) {
          if (value.length > 0) {
            element.show()
            PasswordMeterService.checkPassword(scope, value)
          } else {
            element.hide()
            PasswordMeterService.reset(scope)

            if (
              angular.isUndefined(attrs.passwordrequired) ||
              attrs.passwordrequired !== 'false'
            ) {
              scope.valid = false
            } else {
              scope.valid = true
            }
          }
        })
      }
    }
  }
})()
